(function () { if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing"); })();

(function (Model, Config, Helper) {
  'use strict';

  Model.Usuario = {
    UsuarioId: "",
    AccessToken: "",
    OrigenLoginTipoId: "",
    TipoAsociarCredencial: "",
    xToken: "",
    xValue: "",
    xKey: "",       // Este par�metro solo va para requests de token temporal 
    Retorno: "",
    UsuarioUsuario: "",
    Avatar: 0,
    Email: "",
    EmailCodificado: "",
    UsuarioDetalleNombre: "",
    UsuarioDetalleApellido: "",
    Clave: "",
    Credencial: "",
    Credenciales: [],
    tipoDocumento: "",
    dni: "",
    tipoParticipacion: "",
    UserAgent: "",
    Recaptcha: "",
    Codigo: "",
    SitioId: 1,
    EstadoId: "",
    Ip: "",
    Guid: "",
    UsuarioFacebookId: "",
    FbName: "",
    FbFirstName: "",
    FbLastName: "",
    FbGender: "",
    FbLocale: "",
    FbAgeRange: "",
    FbEmail: "",
    FbBirthday: "",
    FbHometown: "",
    FbLocation: "",
    UsuarioGmailId: "",
    GName: "",
    GFamilyName: "",
    GGivenName: "",
    GBirthday: "",
    GGender: "",
    GCurrentLocation: "",
    GMail: "",
    IsNewUser: false,
    NeedRecaptchaValidation: false,
    HayCookie: 0,
    Experiments: [],
    Provisorio: false,
    AppleId: false
  }

  Model.Window = {
    width: "",
    height: "",
    body: "",
    html: "",
    origenId: "",
    sitioId: "",
    modo: "",
    pagina: "",
    referer: "",
    userAgent: "",
    origenLoginTipoId: "",
    currentStep: "",
    canSubmit: true,
    ip: "",
    keyPress: 0,
    firstStart: true,
    location: window.location.href,
    origin: window.location.origin,
    islockedGmail: false,
    islockedFacebook: false
  }

  Model.Embed = {
    Mobile: false,
    Article: false
  }

  Model.CheckForUpdateArticleContext = function () {
    if (Helper.getURLParameter1('article') != null) {
      Model.Embed.Article = true;
    }
  }

  // ==================================================
  // Inicializacion de las variables de entorno
  // ==================================================       

  Model.updateAccesoWindowModel = function () {
    Model.Window.modo = ((Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1'))) ? Helper.getURLParameter('param1') : Config.defaultModo);
    Model.Window.SitioId = ((Helper.getURLParameter('param2') !== null && Helper.sitioPermitido(parseInt(Helper.getURLParameter('param2')))) ? parseInt(Helper.getURLParameter('param2')) : Config.defaultSitioId);
    Model.Embed.Mobile = (Helper.readCookie("platform") !== '' && Helper.readCookie("platform") != null) ? Helper.readCookie("platform") : false;
    Model.CheckForUpdateArticleContext();

    /*
        Todo esto es para el modo = GLA de Google para obtener el callback sin estar hasheado
    
        Todo este parche sigue en Controller.finalizarAcceder, ahí modifico Model.Window.pagina para que la url concuerde con :
            [Redirect_Uri]#access_token=[ACCESS_TOKEN]&token_type=bearer&state=[STATE_STRING]

        Después de eso sigue el camino original del login. Practicamente todo esto es para modificar la url de redireccionamiento y mandarla a donde necesita google.

        Si cuando estás queriendo acceder a la URL con modo GLA, te aparece un error de Client ID o Redirect URI, está pasando adentro de este método : Controller.inicioView, fijate.
        

        (será un parche feo, pero es un parche feo documentado)            
     */

    if (Model.Window.modo === "GLA") {
      const url = new URL(LN.Model.Window.location);
      const googleParams = {
        response_type: Helper.findGetParameter(url, 'response_type'),
        client_id: Helper.findGetParameter(url, 'client_id'),
        redirect_uri: Helper.findGetParameter(url, 'redirect_uri'),
        scope: Helper.findGetParameter(url, 'scope'),
        state: Helper.findGetParameter(url, 'state')
      }

      ///* Validación de client_id */
      //if (Config.gmId != googleParams.client_id) googleParams.errorGLA = "ERROR GOOGLE CLIENT ID"; /*alert("ERROR GOOGLE CLIENT ID");*/

      ///* Validación de redirect_url  */
      //const splitedRedirectUrl = googleParams.redirect_uri.split("/r/");
      //if (Config.gmRedirect != splitedRedirectUrl[0]) googleParams.errorGLA = "ERROR GOOGLE REDIRECT URL";   /*alert("ERROR GOOGLE REDIRECT URL");*/

      Model.Window.googleParams = googleParams;
    } else {
      // Pagina
      var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
      if (Helper.getURLParameter1('callback') != null) {
        if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
          Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback')))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl);
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl
        }
      } else {
        if (base64Matcher.test(LN.Helper.getURLQueryString())) {
          Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl)
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl
        }
      }
    }



    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : ((Helper.getURLParameter('param3') !== null && Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter('param3')))) ? window.atob(Helper.getURLParameter('param3')) : Config.defaultRedirectUrl)) ;        
    Model.Usuario.SitioId = Model.Window.SitioId;
  }

  Model.updateCambioClaveWindowModel = function () {
    Model.Window.modo = ((Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1'))) ? Helper.getURLParameter('param1') : Config.defaultModo);
    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl);
    if (Helper.getURLParameter1('callback') != null) {
      Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback')))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl);
    } else {
      Model.Window.pagina = Config.defaultRedirectUrl;
    }
  }

  Model.updateCambioClaveUsuarioModel = function () {
    Model.Usuario.Guid = ((Helper.getURLParameter('param2') !== null) ? Helper.getURLParameter('param2') : null);
    Model.Usuario.UsuarioId = ((Helper.getURLParameter('param3') !== null) ? Helper.getURLParameter('param3') : null);
  }

  Model.setXKey = function () {
    Model.Usuario.xKey = Helper.guid();
  }

  Model.unsetXKey = function () {
    Model.Usuario.xKey = '';
  }


})(LN.Model, LN.Config, LN.Helper);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/model.js